<template>
  <div class="debt-detail">
    <el-card class="summary-card">
      <div class="summary-row">
        <span class="summary-label">待结算欠费总额：</span>
        <span class="summary-value">&yen; {{ formatMoney(unsettledSum) }}</span>
      </div>
    </el-card>

    <el-card class="table-card">
      <div slot="header" class="card-header">
        <span>欠费流水明细</span>
        <div class="header-actions">
          <el-select v-model="filterStatus" placeholder="状态筛选" clearable size="small" style="width: 130px" @change="handleSearch">
            <el-option label="未结算" :value="0" />
            <el-option label="已结算" :value="1" />
            <el-option label="已豁免" :value="2" />
            <el-option label="已作废" :value="3" />
          </el-select>
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            size="small"
            style="margin-left: 10px"
            @change="handleSearch"
          />
        </div>
      </div>

      <el-table :data="list" border stripe v-loading="loading" style="width: 100%">
        <el-table-column prop="id" label="ID" width="70" align="center" />
        <el-table-column prop="order_no" label="关联订单号" min-width="180" />
        <el-table-column prop="branch_inviter_reward" label="分身推荐奖励" width="130" align="center">
          <template slot-scope="scope">&yen; {{ formatMoney(scope.row.branch_inviter_reward) }}</template>
        </el-table-column>
        <el-table-column prop="reserve_reward" label="预留奖励" width="110" align="center">
          <template slot-scope="scope">&yen; {{ formatMoney(scope.row.reserve_reward) }}</template>
        </el-table-column>
        <el-table-column prop="platform_fee" label="总台服务费" width="120" align="center">
          <template slot-scope="scope">&yen; {{ formatMoney(scope.row.platform_fee) }}</template>
        </el-table-column>
        <el-table-column prop="total_debt" label="欠费总额" width="120" align="center">
          <template slot-scope="scope">
            <span style="color: #3a8ee6; font-weight: bold">&yen; {{ formatMoney(scope.row.total_debt) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status_text" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="debtStatusType(scope.row.status)" size="small">{{ scope.row.status_text }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="150" show-overflow-tooltip />
        <el-table-column prop="create_time" label="创建时间" width="170" align="center" />
      </el-table>

      <el-pagination
        v-if="total > 0"
        class="pagination"
        background
        layout="prev, pager, next, total"
        :total="total"
        :page-size="pageSize"
        :current-page.sync="currentPage"
        @current-change="loadData"
      />
    </el-card>
  </div>
</template>

<script>
import { getDebtList } from '@/api'

export default {
  name: 'DebtDetail',
  data() {
    return {
      list: [],
      total: 0,
      unsettledSum: 0,
      currentPage: 1,
      pageSize: 10,
      loading: false,
      filterStatus: '',
      dateRange: null
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          limit: this.pageSize
        }
        if (this.filterStatus !== '' && this.filterStatus !== null) {
          params.status = this.filterStatus
        }
        if (this.dateRange && this.dateRange.length === 2) {
          params.start = this.dateRange[0] + ' 00:00:00'
          params.end = this.dateRange[1] + ' 23:59:59'
        }
        const res = await getDebtList(params)
        this.list = res.data || []
        this.total = res.total || 0
        this.unsettledSum = res.unsettledSum || 0
      } catch (e) {
        console.error('加载欠费流水失败:', e)
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.currentPage = 1
      this.loadData()
    },
    formatMoney(val) {
      if (!val && val !== 0) return '--'
      return Number(val).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    debtStatusType(status) {
      const map = { 0: 'warning', 1: 'success', 2: 'info', 3: 'danger' }
      return map[status] || 'info'
    }
  }
}
</script>

<style scoped>
.debt-detail { padding: 0; }
.summary-card { margin-bottom: 20px; }
.summary-row { display: flex; align-items: center; font-size: 16px; }
.summary-label { color: #606266; }
.summary-value { color: #3a8ee6; font-weight: bold; font-size: 20px; }
.card-header { display: flex; justify-content: space-between; align-items: center; font-weight: bold; }
.header-actions { display: flex; align-items: center; }
.pagination { margin-top: 20px; text-align: center; }
</style>
